export default function jsonStringify(json?: any) {
  return json ? JSON.stringify(json) : null;
}
